import ReportPageTemplate from "./Components/ReportPageTemplate";

export default function ReservationReports() {
  const reportTypes = [
    { label: "Arrival List", api: "/pms/reports/arrival-list" },
    { label: "Depature List", api: "/pms/reports/depature-list" },
    {
      label: "Cancelled Reservations",
      api: "/pms/reports/cancelled-reservations",
    },
    { label: "No Show Reservations", api: "/pms/reports/no-show-reservations" },
    { label: "Reservation Activity", api: "/pms/reports/reservation-activity" },
    { label: "Void Reservations", api: "/pms/reports/void-reservations" },
  ];

  return (
    <ReportPageTemplate
      title="Reservation Reports"
      desc="Arrivals, cancellations, no-shows & activity logs"
      reportTypes={reportTypes}
    />
  );
}
